import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, forkJoin } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { MessageService } from '../services/message.service';

const routesUrl = "assets/json/routes.json";
const stopsUrl = "assets/json/stops.json";
const stationsUrl = "assets/json/stations.json";

@Injectable({
  providedIn: 'root'
})

export class OmniSearchService {

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  private stations: any;
  private stops: any;

  constructor(private http: HttpClient, private messageService: MessageService) { }

  get():Observable<any[]> {
    return this.http.get(stationsUrl)
    .pipe(
      map ((array: any) => array = this.transform(array, 'station')),
      tap (_ => this.log('fetched routes')),
      catchError (this.handleError<any[]>('get', []))
    );
  }

  search(term: string):Observable<any[]> {
    var stations = this.searchStations(term);
    var stops = this.searchStop(term);
    var routes = this.searchRoutes(term);

    var found = forkJoin( routes, stations, stops).subscribe(results => {
      var combined : any; // = {...results[0], ...object2 }
      if(typeof(results[0]) == "object" && typeof(results[1]) == "object" && typeof(results[2]) == "object"){
        combined =  [{...results[0], ...results[1], ...results[2] }];
      }
      console.log(combined);

      return combined;
    });

    return routes;
  }

  /* GET stations whose name contains search term */
  public searchStations(term: string): Observable<any[]> {
    if (!term.trim()) {
      return of([]);
    }
    return this.http.get(stationsUrl)
    .pipe(
      map ((array: any) => array = this.find(array, term)),
      tap (_ => this.log('fetched trains')),
      catchError (this.handleError<any[]>('get', []))
    );
  }

  /* GET stops whose name contains search term */
  public searchStop(term: string): Observable<any[]> {
    if (!term.trim()) {
      return of([]);
    }
    return this.http.get(stopsUrl)
    .pipe(
      map ((array: any) => array = this.find(array, term)),
      tap (_ => this.log('fetched trains')),
      catchError (this.handleError<any[]>('get', []))
    );
  }

  /* GET routes whose name contains search term */
  public searchRoutes(term: string): Observable<any[]> {
    if (!term.trim()) {
      return of([]);
    }
    return this.http.get(routesUrl)
    .pipe(
      map ((array: any) => array = this.find(array, term)),
      tap (_ => this.log('fetched trains')),
      catchError (this.handleError<any[]>('get', []))
    );
  }

  private find(response: any, term: string): any{
    var searched: any[] = [];
    for(const array of response){
      if(this.searchArray(array, term)){
        searched.push(array);
      }
    }

    return searched;
  }

  private searchArray(array: any, term: string){
    for( let i in array) {
      if(i == 'StopName' || (i == 'route_name' && array["sequence"] != null )){
        if(array[i].toLowerCase().indexOf(term.toLowerCase()) !== -1){
          return true;
        }
      }
    }

    return false;
  }
  private transform(response: any, type: string){
    for (const d of response){
      if(type == "station"){

      }
    }
    return response
  }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log('${operation} failed: ${error.message}');

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a RouteService message with the MessageService */
  private log(message: string) {
    this.messageService.add(`RouteService: ${message}`);
  }
}
